module.exports = __webpack_public_path__ + "static/buttonAriaDocs-bd8c2a3cc3527f07520260c85cbd7f25.png";